import React from 'react';
import { Link } from 'react-router-dom';

const AdminQuickNav = ({ active = '' }) => {
  const btn = (name) =>
    name === active ? 'btn btn-primary btn-lg mr-2' : 'btn border btn-lg mr-2';

  return (
    <div className="card card-primary mb-3">
      <div className="card-body py-3">
        <div className="row d-flex">

          <div className="ml-2">
            <Link
              to="/admin/landing-page-content"
              className={btn('content')}
            >
              Landing Page Content
            </Link>
          </div>

          <div>
            <Link
              to="/admin/landing-page/service"
              className={btn('services')}
            >
              Services
            </Link>
          </div>

          <div>
            <Link
              to="/admin/landing-page-products"
              className={btn('products')}
            >
              Products
            </Link>
          </div>

          <div>
            <Link
              to="/admin/order-list"
              className={btn('orders')}
            >
              Order List
            </Link>
          </div>

          <div>
            <Link
              to="/admin/interest-list"
              className={btn('interest')}
            >
              Interest List
            </Link>
          </div>

        </div>
      </div>
    </div>
  );
};

export default AdminQuickNav;
